/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PatchManagementAwsPatchGroupBaselineData {
    getFixupPrototypeFunction() { return PatchManagementAwsPatchGroupBaselineData.fixupPrototype; }

    static newInstance(model: Partial<PatchManagementAwsPatchGroupBaselineData>): PatchManagementAwsPatchGroupBaselineData {
        let obj = Object.assign(new PatchManagementAwsPatchGroupBaselineData(), model);
        PatchManagementAwsPatchGroupBaselineData.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PatchManagementAwsPatchGroupBaselineData>): PatchManagementAwsPatchGroupBaselineData {
        if (!model) return null;
        return PatchManagementAwsPatchGroupBaselineData.newInstance(<PatchManagementAwsPatchGroupBaselineData> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PatchManagementAwsPatchGroupBaselineData) {
        if (!obj) return;

        models.PatchManagementAwsPatchGroupBaselineData.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PatchManagementAwsPatchGroupBaselineData): boolean {
        Object.setPrototypeOf(obj, PatchManagementAwsPatchGroupBaselineData.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the patch group registered with the patch baseline
     */
    patch_group: string;

    /**
     * ID of the patch baseline
     */
    baseline_id: string;

    /**
     * Name of the patch baseline
     */
    name: string;

    /**
     * Operating system the patch baseline
     */
    operating_system: string;

    /**
     * Description of the patch baseline
     */
    description: string;

}
